import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import { IHistoryEmployeeStateTransactionRecordDto } from "../../../dtos/transactions/IHistoryEmployeeStateTransactionRecordDto";

interface IProps {
  items: IHistoryEmployeeStateTransactionRecordDto[];
}

export const HistoryEmployeeStateTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="employeeId" dataType={"string"} caption="Employee " />
          <Column width={150} dataField="companyId" dataType={"string"} caption="Company " />
          <Column width={150} dataField="positionId" dataType={"string"} caption="Position " />
          <Column width={150} dataField="divisionId" dataType={"string"} caption="Division " />
          <Column width={150} dataField="hireDate" dataType={"datetime"} caption="Hire Date " />
          <Column width={150} dataField="dismissDate" dataType={"datetime"} caption="Dismiss Date " />
          <Column width={150} dataField="workScheduleId" dataType={"string"} caption="Work Schedule " />

          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
